class UserInputOption extends BaseOption {
    
    constructor(container) {
        super(container);

        if (!this.container || !this.container.length) return;
        
        this.initializeInputs();
    }

    initializeInputs() {
        // Разделяем обработчики для числовых и текстовых полей
        this.container.find('input[type="text"]').each((_, input) => {
            const $input = $(input);
            const isNumeric = $input.data('step') !== undefined; // Проверяем, является ли поле числовым

            if (isNumeric) {
                // Для числовых полей
                $input.on('input', (e) => {
                    let value = $input.val();
                    value = value.replace(',', '.');
                    
                    // Проверяем, является ли введенное значение числом
                    if (value && !/^\d*\.?\d*$/.test(value)) {
                        value = value.replace(/[^\d.]/g, '');
                    }
                    
                    $input.val(value);
                });

                // Форматирование при потере фокуса только для числовых полей
                $input.on('blur', (e) => {
                    let value = $input.val();
                    if (value) {
                        const numValue = parseFloat(value);
                        if (!isNaN(numValue)) {
                            $input.val(this.formatDecimal(numValue));
                        }
                    }
                });
            }
        });

        this.container.find('.number-controls button').on('click', (e) => {
            const $button = $(e.currentTarget);
            const $input = $button.closest('.input-wrapper').find('input');
            const isIncrease = $button.hasClass('increase');
            
            this.updateNumberValue($input, isIncrease);
        });

        this.container.find('input').on('change', (e) => {
            const $input = $(e.target);
            const isNumeric = $input.data('step') !== undefined;

            if (isNumeric) {
                this.validateNumberInput($input);
            }

            const value = $input.val();
            const $optionValue = $input.closest('.pc-option-value');
            
            // Обновляем data-value опции
            $optionValue.attr('data-value', isNumeric ? this.normalizeDecimal(value) : value);
            
            const index = $optionValue.data('index');
            const optionSlug = $input.closest('.pc-option-value').data('option-slug');
            
            $(document).trigger('option-changed', {
                element: $optionValue,
                value: value,
                index: index,
                optionSlug: optionSlug
            });
        });
    }

    updateNumberValue($input, isIncrease) {
        const step = parseFloat(this.normalizeDecimal($input.data('step'))) || 1;
        const currentValue = parseFloat(this.normalizeDecimal($input.val())) || 0;
        
        const precision = step.toString().split('.')[1]?.length || 0;
        const multiplier = Math.pow(10, precision);
        
        const stepAsInt = step * multiplier;
        const valueAsInt = Math.round(currentValue * multiplier);
        
        let newValueAsInt;
        if (isIncrease) {
            newValueAsInt = valueAsInt + stepAsInt;
        } else {
            newValueAsInt = valueAsInt - stepAsInt;
        }
        
        const newValue = newValueAsInt / multiplier;
        
        // Обновляем data-value опции перед изменением значения инпута
        const $optionValue = $input.closest('.pc-option-value');
        $optionValue.attr('data-value', newValue);
        
        $input.val(this.formatDecimal(newValue)).trigger('change');
    }

    validateNumberInput($input) {
        const step = parseFloat(this.normalizeDecimal($input.data('step'))) || 1;
        const value = parseFloat(this.normalizeDecimal($input.val())) || 0;
        
        const roundedValue = Math.round(value / step) * step;
        
        if (value !== roundedValue) {
            const displayValue = this.roundToStep(roundedValue, step);
            
            const message = window.pc_ajax_object?.value_must_be_multiple_of || 'Value must be multiple of {step}. Nearest valid value: {value}';
            const formattedMessage = message
                .replace('{step}', this.formatDecimal(step))
                .replace('{value}', this.formatDecimal(displayValue));
            
            this.showValidationMessage($input, formattedMessage);
            $input.val(this.formatDecimal(displayValue));
        } else {
            this.hideValidationMessage($input);
        }
    }

    roundToStep(value, step) {
        const decimals = step.toString().split('.')[1]?.length || 0;
        return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    }

    showValidationMessage($input, message) {
        let $message = $input.siblings('.validation-message');
        
        if (!$message.length) {
            $message = $('<div class="validation-message"></div>');
            $input.after($message);
        }
        
        $message.text(message).fadeIn();
        
        setTimeout(() => {
            this.hideValidationMessage($input);
        }, 3000);
    }

    hideValidationMessage($input) {
        const $message = $input.siblings('.validation-message');
        if ($message.length) {
            $message.fadeOut();
        }
    }

    // Вспомогательный метод для замены точки на запятую
    formatDecimal(value) {
        return value.toString().replace('.', ',');
    }

    // Вспомогательный метод для замены запятой на точку при вычислениях
    normalizeDecimal(value) {
        return value.toString().replace(',', '.');
    }
} 